import { combineReducers } from 'redux';
import groupsById, { getGroupById } from './groupsById';
import * as fromDraggableGroup from './draggableGroup';
import draggableTexts, * as fromDraggableTexts from './draggableTexts';

export const getDraggablesTextsByPage = (state, page) =>
  fromDraggableTexts.getDraggablesTextsByPage(state.draggableTexts, page);

export const getIsGroupActive = (state, groupId) =>
  fromDraggableGroup.getIsGroupActive(getGroupById(state.groupsById, groupId));

export const getIsGroupDragged = (state, groupId) =>
  fromDraggableGroup.getIsGroupDragged(getGroupById(state.groupsById, groupId));

export const getGroupIsReturning = (state, groupId) =>
  fromDraggableGroup.getGroupIsReturning(getGroupById(state.groupsById, groupId));

export const getGroupOffset = (state, groupId) =>
  fromDraggableGroup.getGroupOffset(getGroupById(state.groupsById, groupId));

const draggables = combineReducers({
  draggableTexts,
  groupsById,
});

export const getGroupText = (state, groupId) =>
  fromDraggableGroup.getGroupText(getGroupById(state.groupsById, groupId));

export const getGroupUuid = (state, groupId) =>
  fromDraggableGroup.getGroupUuid(getGroupById(state.groupsById, groupId));

export default draggables;
